import { SkeletonTypography } from '@apeiron/temp'
import { Box, styled } from '@mui/material'
import { useOrbitalTrackAttachContext } from '@src/contexts/orbitalTrack/OrbitalTrackAttachContext'
import * as R from 'ramda'
import { FC } from 'react'
import { Trans, useTranslation } from 'react-i18next'

const Container = styled(Box)`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 16px;
  ${props => props.theme.breakpoints.up('res1280')} {
    padding: 0px 16px;
  }
`

const StarName = styled(SkeletonTypography)`
  font-weight: 400;
  font-size: 24px;
  line-height: 24px;
  min-width: 120px;
`

const TrackNumber = styled(SkeletonTypography)`
  font-size: 16px;
  font-weight: 300;
  line-height: 16px;
  min-width: 240px;
  strong {
    color: #ffb10b;
    font-weight: 700;
  }
`

const OrbitalTrackStarInfo: FC<Props> = props => {
  const { className } = props

  const { loading, star, trackDetail } = useOrbitalTrackAttachContext()

  const { t } = useTranslation()

  const tier = Number(R.propOr(0, 'level', star?.tier)) + 1

  const name = star ? `T${tier} ${star.name}` : '-'

  return (
    <Container className={className}>
      <StarName loading={loading}>{name}</StarName>
      <TrackNumber loading={loading}>
        <Trans>
          {t('godiverse.orbital_track.track_count', {
            total: trackDetail?.totalOrbitalTrackCount ?? '-',
            available: trackDetail?.availableOrbitalTrackCount ?? '-'
          })}
        </Trans>
      </TrackNumber>
    </Container>
  )
}

type Props = {
  className?: string
}
export default OrbitalTrackStarInfo
